import type { TrendingData } from '../ui/type';

export const sortOrder = ['event', 'market', 'crypto', 'news', 'question', 'portfolio'];

export function dedupeTrendingByType(list: TrendingData[]) {
  const seenTypes = new Set<TrendingData['type']>();

  return list.filter((item) => {
    if (seenTypes.has(item.type)) return false;
    seenTypes.add(item.type);
    return true;
  });
}

export function getCardBackground(trend: TrendingData, kind: string) {
  if (kind === 'event') {
    return findFirstImageUrl(trend.event) || findFirstImageUrl(trend.event?.news);
  }
  if (kind === 'market') return trend.market?.event.cover || trend.market?.event.image;
  if (kind === 'news') return trend.news?.events?.find((event) => event.image)?.image;
  if (kind === 'crypto') return '/image/crypto.png';
  if (kind === 'portfolio') return '/image/portfolio.png';
  return '/image/general.png';
}

function findFirstImageUrl(value: unknown): string | undefined {
  const visited = new WeakSet<object>();

  function visit(item: unknown): string | undefined {
    if (typeof item === 'string') {
      return isImageUrl(item) ? item : undefined;
    }

    if (!item || typeof item !== 'object') return undefined;
    if (visited.has(item)) return undefined;
    visited.add(item);

    if (Array.isArray(item)) {
      for (const child of item) {
        const image = visit(child);
        if (image) return image;
      }
      return undefined;
    }

    const record = item as Record<string, unknown>;
    const priorityKeys = ['image_url', 'image', 'cover', 'cover_web', 'icon', 'market_image'];
    for (const key of priorityKeys) {
      const image = visit(record[key]);
      if (image) return image;
    }

    for (const child of Object.values(record)) {
      const image = visit(child);
      if (image) return image;
    }

    return undefined;
  }

  return visit(value);
}

function isImageUrl(value: string) {
  if (!/^https?:\/\//.test(value)) return false;

  return (
    /\.(png|jpe?g|webp|gif|avif|svg)(\?.*)?$/i.test(value) ||
    /\/image\//i.test(value) ||
    /images/i.test(value)
  );
}
